module.exports = __webpack_public_path__ + "static/media/next-banner.ea3040f1.jpg";